import React from "react";

import { truncatedBodyTextStyle } from "./bodyTextStyle";

export default ({ node }) => {
  return (
    <div style={truncatedBodyTextStyle}>
      {node.node_data?.subject?.length ? (
        node.node_data.subject
      ) : "Build your email"}
    </div>
  );
};
